import React, { useState, useEffect, useRef } from 'react';
import { getFirestore, collection, query, getDocs, doc, setDoc, Timestamp } from "@firebase/firestore";
import { app } from '../../firebase.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import swal from 'sweetalert';
import { formatKes, normalizeAmount, toDateValue } from '../../utils/financeWorkflow';
import './assets.css';

const db = getFirestore(app);

function AssetRegisterComp() {

    const [modalShowUp, setModalShowUp] = useState(false);
    const [branchesList, setBranchesList] = useState([]);
    const [requiLists, setRequiLists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [branchMapping, setBranchMapping] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [categoryFilter, setCategoryFilter] = useState('All');
    const [campusFilter, setCampusFilter] = useState('All');


    useEffect(() => {
        const fetchBranches = async () => {
            const q = query(collection(db, 'Branches'));
            const querySnapshot = await getDocs(q);
            const branches = [];
            const mapping = {};
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                branches.push({ id: doc.id, ...data });
                mapping[doc.id] = data.branchName;
            });
            setBranchesList(branches);
            setBranchMapping(mapping);
        };
        fetchBranches();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const q = query(collection(db, 'AssetRegister'));
                const querySnapshot = await getDocs(q);
                setRequiLists(querySnapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
            } catch (error) {
                console.error('Failed to load assets:', error);
                swal('Error', 'Assets could not be loaded right now.', 'error');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    function MyUpdateModal(props) {
        return (
            <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered contentClassName="assetsModal">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add an Asset
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Select a Campus</Form.Label>
                        <Form.Select aria-label="Default select example" ref={selectedCampus} >
                            {branchesList.map((vendor) => (
                                <option key={vendor.id} value={vendor.id}>{vendor.branchName}</option>
                            ))}
                             <option value="General">General</option>
                        </Form.Select> 
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Asset Name</Form.Label>
                        <Form.Control type="text"  ref={assetName}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Category</Form.Label>
                        <Form.Select aria-label="Default select example" ref={assetCategory} >
                            <option value="IT & Electronics">IT & Electronics</option>
                            <option value="Furniture & Fixtures">Furniture & Fixtures</option>
                            <option value="Vehicles & Transportation">Vehicles & Transportation</option>
                            <option value="Machinery & Equipment">Machinery & Equipment</option>
                            <option value="Building & Infrastructure">Building & Infrastructure</option>
                            <option value="Office Supplies & Consumables">Office Supplies & Consumables</option>
                            <option value="Educational & Training Resources">Educational & Training Resources</option>
                            <option value="Library & Learning Resources">Library & Learning Resources</option>
                            <option value="Art, Décor, & Cultural Assets">Art, Décor, & Cultural Assets</option>
                            <option value="Miscellaneous">Miscellaneous</option>
                        </Form.Select> 
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Brand/Model</Form.Label>
                        <Form.Control type="text" ref={brandModel}  />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Serial Number</Form.Label>
                        <Form.Control type="text" ref={serialNumber} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" ref={assetDesc} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Date of Purchase</Form.Label>
                        <Form.Control type="date" ref={dateOfPurchase} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Purchase Price</Form.Label>
                        <Form.Control type="number" ref={purchasePrice} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Current Value</Form.Label>
                        <Form.Control type="text" ref={currentValue} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Assigned to</Form.Label>
                        <Form.Control type="text" ref={assignedTo} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Assignee Phone Number</Form.Label>
                        <Form.Control type="text" ref={assPhoneNumber} />
                    </Form.Group> 

                </Modal.Body>

                <Modal.Footer>
                    <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
                    <Button variant="primary" id='submitBtn' onClick={addAnAsset} >Submit</Button>
                    <Button variant="primary" disabled id='spinnerbtn' style={{ display: 'none' }}>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span> Submitting...</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }


    const selectedCampus = useRef();
    const assetName = useRef();
    const assetCategory = useRef();
    const brandModel = useRef();
    const assetDesc = useRef();
    const dateOfPurchase = useRef();
    const purchasePrice = useRef();
    const currentValue = useRef();
    const assignedTo = useRef();
    const assPhoneNumber = useRef();
    const serialNumber = useRef();
    

    function addAnAsset() {
        const assetNameValue = assetName.current.value;
        const assetCategoryValue = assetCategory.current.value;
        const brandModelValue = brandModel.current.value;
        const assetDescValue = assetDesc.current.value;
        const dateOfPurchaseValue = dateOfPurchase.current.value;
        const purchasePriceValue = purchasePrice.current.value;
        const currentValueValue = currentValue.current.value;
        const assignedToValue = assignedTo.current.value;
        const assPhoneNumberValue = assPhoneNumber.current.value;
        const selectedCampusValue = selectedCampus.current.value;
        const serialNumberValue = serialNumber.current.value;
    
        // Show spinner and hide submit button
        document.getElementById("submitBtn").style.display = "none";
        document.getElementById("spinnerbtn").style.display = "block";
    
        // Generate new document reference and set document in Firestore
        const newDataRef = doc(collection(db, "AssetRegister"));
        setDoc(newDataRef, {
            assetID: generateAssetID(), // Generate and add Asset ID
            selectedCampus: selectedCampusValue,
            timeStamp: Timestamp.now(),
            assetName: assetNameValue,
            assetCategory: assetCategoryValue,
            brandModel: brandModelValue,
            assetDesc: assetDescValue,
            dateOfPurchase: new Date(dateOfPurchaseValue), // Assuming date input
            purchasePrice: purchasePriceValue,
            currentValue: currentValueValue,
            assignedTo: assignedToValue,
            assPhoneNumber: assPhoneNumberValue,
            docID: newDataRef.id,
            status: "On Service",
            serialNumber:serialNumberValue
        }).then(() => {
            swal("Success!", "Asset added successfully", "success");
            window.location.reload();
        }).catch((error) => {
            swal("Error!", "There was an issue adding the asset: " + error.message, "error");
            document.getElementById("submitBtn").style.display = "block";
            document.getElementById("spinnerbtn").style.display = "none";
        });
    }
    
    function generateAssetID() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
        for (let i = 0; i < 8; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }
    

    function viewComments(docID){

    }

    const assetCategories = [...new Set(requiLists.map((asset) => asset.assetCategory).filter(Boolean))].sort();
    const filteredAssets = requiLists.filter((asset) => {
        const queryText = searchTerm.trim().toLowerCase();
        const campus = asset.selectedCampus === 'General'
            ? 'General'
            : branchMapping[asset.selectedCampus] || asset.selectedCampus || 'Campus not set';
        const matchesSearch = !queryText || [
            asset.assetName,
            asset.assetCategory,
            asset.serialNumber,
            asset.assetID,
            asset.brandModel,
            asset.assignedTo,
            campus
        ].filter(Boolean).join(' ').toLowerCase().includes(queryText);
        const matchesCategory = categoryFilter === 'All' || asset.assetCategory === categoryFilter;
        const matchesCampus = campusFilter === 'All' || asset.selectedCampus === campusFilter;
        return matchesSearch && matchesCategory && matchesCampus;
    });
    const totalPurchaseValue = requiLists.reduce((total, asset) => total + normalizeAmount(asset.purchasePrice), 0);
    const inServiceCount = requiLists.filter((asset) => String(asset.status || '').toLowerCase() === 'on service').length;
    const formatAssetDate = (value) => {
        const date = toDateValue(value);
        return date ? date.toLocaleDateString('en-KE', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
    };
    const formatAssetValue = (value) => (
        value === undefined || value === null || String(value).trim() === '' ? '—' : formatKes(value)
    );

  return (
    <div className="assetsPage">
        <header className="assetsHeader">
            <div>
                <span className="assetsEyebrow">Finance / Assets</span>
                <h1>Asset register</h1>
                <p>Keep a clear record of campus assets, purchase dates, and values.</p>
            </div>
            <button type="button" className="assetsAddButton" onClick={() => setModalShowUp(true)}>
                <FontAwesomeIcon icon={faPlus} /> Add asset
            </button>
        </header>

        <section className="assetsOverview" aria-label="Asset summary">
            <div className="assetsMetric">
                <span>Registered assets</span>
                <strong>{requiLists.length}</strong>
            </div>
            <div className="assetsMetric">
                <span>Purchase value</span>
                <strong>{formatKes(totalPurchaseValue)}</strong>
            </div>
            <div className="assetsMetric">
                <span>Categories</span>
                <strong>{assetCategories.length}</strong>
            </div>
            <div className="assetsMetric">
                <span>In service</span>
                <strong>{inServiceCount}</strong>
            </div>
        </section>

        <section className="assetsRegister">
            <div className="assetsRegisterHeader">
                <div>
                    <h2>Asset list</h2>
                    <p>Search and filter the assets recorded across campuses.</p>
                </div>
                <div className="assetsFilters">
                    <Form.Control
                        type="search"
                        value={searchTerm}
                        onChange={(event) => setSearchTerm(event.target.value)}
                        placeholder="Search assets"
                        aria-label="Search assets"
                    />
                    <Form.Select value={categoryFilter} onChange={(event) => setCategoryFilter(event.target.value)} aria-label="Filter by category">
                        <option value="All">All categories</option>
                        {assetCategories.map((category) => <option key={category} value={category}>{category}</option>)}
                    </Form.Select>
                    <Form.Select value={campusFilter} onChange={(event) => setCampusFilter(event.target.value)} aria-label="Filter by campus">
                        <option value="All">All campuses</option>
                        <option value="General">General</option>
                        {branchesList.map((branch) => <option key={branch.id} value={branch.id}>{branch.branchName}</option>)}
                    </Form.Select>
                </div>
            </div>

            {loading ? (
                <div className="assetsState"><Spinner animation="border" role="status" /><span>Loading assets...</span></div>
            ) : filteredAssets.length === 0 ? (
                <div className="assetsEmpty">
                    <h3>{requiLists.length === 0 ? 'No assets recorded' : 'No matching assets'}</h3>
                    <p>{requiLists.length === 0 ? 'Add an asset to start building the register.' : 'Try a different search or filter.'}</p>
                    {requiLists.length === 0 ? (
                        <button type="button" className="assetsAddButton" onClick={() => setModalShowUp(true)}>
                            <FontAwesomeIcon icon={faPlus} /> Add asset
                        </button>
                    ) : null}
                </div>
            ) : (
                <div className="assetsTableWrap">
                    <table className="assetsTable">
                        <thead>
                            <tr>
                                <th>Asset</th>
                                <th>Campus</th>
                                <th>Serial number</th>
                                <th>Purchased</th>
                                <th>Purchase value</th>
                                <th>Current value</th>
                                <th>Status</th>
                                <th aria-label="Actions" />
                            </tr>
                        </thead>
                        <tbody>
                            {filteredAssets.map((asset) => (
                                <tr key={asset.id}>
                                    <td data-label="Asset">
                                        <div className="assetsName">
                                            <strong>{asset.assetName || 'Unnamed asset'}</strong>
                                            <span>{[asset.assetCategory, asset.brandModel].filter(Boolean).join(' · ') || 'Uncategorised'}</span>
                                        </div>
                                    </td>
                                    <td data-label="Campus">{asset.selectedCampus === 'General' ? 'General' : branchMapping[asset.selectedCampus] || 'Campus not set'}</td>
                                    <td data-label="Serial number">{asset.serialNumber || '—'}</td>
                                    <td data-label="Purchased">{formatAssetDate(asset.dateOfPurchase)}</td>
                                    <td data-label="Purchase value">{formatAssetValue(asset.purchasePrice)}</td>
                                    <td data-label="Current value">{formatAssetValue(asset.currentValue)}</td>
                                    <td data-label="Status"><span className="assetsStatus">{asset.status || '—'}</span></td>
                                    <td data-label="Actions" className="assetsActionsCell">
                                        <button type="button" className="assetsTextButton" onClick={() => viewComments(asset.docID)}>View</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>

        <MyUpdateModal show={modalShowUp} onHide={() => setModalShowUp(false)} />
    </div>
  )
}


export default AssetRegisterComp
